import React from 'react'
import style from "./index.module.scss"
import { useReactRouter } from 'hooks/useReactRouter'
import Icon from 'components/Icon/Icon'

interface IProps {
  title: string
  titleSize?: string
  color?: 'green' | 'bule' | 'orange'
  left?: boolean
  leftUrl?: string
  leftSize?: string
  clickLeft?: () => any
}

function Title ({ title, clickLeft, titleSize = '.32rem', color = 'green', left, leftUrl, leftSize = '24px' }: IProps) {
  const { history } = useReactRouter()

  function onClickLeft () {
    if (clickLeft) {
      return clickLeft()
    }
    history.push(leftUrl || '#')
  }

  return (
    <div className={style.title}>
      {
        left
          ? (
            <div
              onClick={onClickLeft}
              className={style.left}>
              <Icon 
                fontSize={leftSize}
                icon="iconicon_back" />
            </div>
          )
          : null
      }
      <div
        style={{ fontSize: titleSize }}
        className={style.text + ' ' + style[color]}>
        { title }
      </div>
    </div>
  )
}

export default Title
